<template>
  <!-- features section -->
  <section class="features pb-5">
    <!-- bg image -->
    <img
      src="@/assets/images/steps-bg-2.svg"
      alt="features bg"
      class="features__bg"
    />
    <!-- end bg image -->

    <!-- shadow image -->
    <img
      src="@/assets/images/shadow-bg.png"
      alt="shadow bg"
      class="shadow-bg"
    />
    <!-- shadow image -->

    <div class="container py-5">
      <h2
        class="features__heading page-heading text-center"
        data-aos="fade-up"
        data-aos-offset="0"
      >
        3 Easy-Steps
      </h2>
      <div class="features__row">
        <FeatureCard
          v-for="(feature, index) in features"
          :key="feature.id"
          :feature="feature"
          :hideSvgLine="index !== features.length - 1"
          :data-aos-delay="200 * index"
          :data-aos-svg-delay="(index + 1) * 800"
        />

        <!-- floating icons -->
        <img
          src="@/assets/images/icons/triangle.svg"
          alt="triangle icon"
          class="features__row__icon triangle-icon rotate-360"
          width="35"
        />
        <img
          src="@/assets/images/icons/x.svg"
          alt="x icon"
          class="features__row__icon x-icon rotate-360"
        />
        <img
          src="@/assets/images/icons/square.svg"
          alt="square icon"
          class="features__row__icon square-icon rotate-360"
        />
        <img
          src="@/assets/images/icons/square.svg"
          alt="square icon"
          class="features__row__icon square-icon--sm rotate-360"
          width="25"
        />
        <!-- end floating icons -->
      </div>
    </div>
  </section>
  <!-- end features section -->
</template>

<script>
import FeatureCard from "@/components/home/FeatureCard.vue";
export default {
  name: "features",
  components: { FeatureCard },
  data() {
    return {
      features: [
        {
          id: 1,
          number: 1,
          title: "JOIN",
          desc: "Subscribe to 365games.net and choose your membership (1, 3 or 6-months)",
        },
        {
          id: 2,
          number: 2,
          title: "PLAY",
          desc: "Play your favorite battleroyal game (COD Warzone, Apex Legend or Fortnite)",
        },
        {
          id: 3,
          number: 3,
          title: "EARN",
          desc: "Earn up to 1 million dollars by playing tournaments or by lcuky draws!",
        },
      ],
    };
  },
};
</script>
